import React, {useState} from 'react';
import {Box, Button, Card, CardActions, CardContent, CardMedia, Chip, Tooltip} from '@mui/material';
import Typography from '@mui/material/Typography';
import DynamicIcon from './DynamicIcon';

const PLATFORM_LABELS = {control4: 'Control4', rti: 'RTI', elan: 'Elan'};

export const DriverCard = ({driver}) => {
	const {title, img, text, html, marketplace_link, platform, categories = []} = driver;
	const [expanded, setExpanded] = useState(false);
	const isLong = (text || '').length > 220;

	return (
		<Card elevation={2}
		      sx={{
			      height: '100%',
			      display: 'flex',
			      flexDirection: 'column',
			      borderRadius: 3,
			      transition: 'transform 0.2s ease, box-shadow 0.2s ease',
			      '&:hover': {transform: 'translateY(-4px)', boxShadow: 6},
		      }}>
			{img &&
				<CardMedia component="img" image={img} alt={title}
				           sx={{height: 170, objectFit: 'contain', padding: 2, backgroundColor: '#ffffff'}}/>
			}
			<CardContent sx={{flexGrow: 1, paddingTop: 1}}>
				<Box sx={{display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 1}}>
					<Typography variant="subtitle1" sx={{fontWeight: 700, lineHeight: 1.3}}>
						{title}
					</Typography>
					{platform &&
						<Chip label={PLATFORM_LABELS[platform] || platform} color="primary" size="small"
						      sx={{fontWeight: 600, flexShrink: 0, marginTop: '2px'}}/>
					}
				</Box>
				<Box sx={{display: 'flex', gap: 0.5, paddingTop: 0.5, paddingBottom: 1}}>
					{categories.map((category) => (
						<Tooltip title={category} key={category}>
							<Box sx={{display: 'flex'}}>
								<DynamicIcon name={category} style={{fontSize: '22px'}}/>
							</Box>
						</Tooltip>
					))}
				</Box>
				<Box sx={{
					typography: 'body2',
					...(expanded ? {} : {
						display: '-webkit-box',
						WebkitLineClamp: 4,
						WebkitBoxOrient: 'vertical',
						overflow: 'hidden',
					}),
					'& p': {margin: 0, marginBottom: 1},
					'& ul, & ol': {margin: 0, marginBottom: 1, paddingLeft: 2.5},
					'& li': {marginBottom: 0.25},
					'& h3, & h4, & h5, & h6': {
						margin: 0,
						marginTop: 1,
						marginBottom: 0.5,
						fontSize: '0.85rem',
						fontWeight: 700,
						color: 'primary.main',
					},
					'& a': {color: 'primary.main'},
				}}
				     dangerouslySetInnerHTML={{__html: html || text}}/>
				{isLong &&
					<Button size="small" onClick={() => setExpanded(!expanded)}
					        sx={{padding: 0, minWidth: 0, textTransform: 'none'}}>
						{expanded ? 'Show less' : 'Read more'}
					</Button>
				}
			</CardContent>
			<CardActions sx={{padding: 2, paddingTop: 0}}>
				<Button fullWidth size="medium" variant="contained" sx={{borderRadius: 5, fontWeight: 600}}
				        href={marketplace_link} target="_blank" rel="noopener">
					Get driver
				</Button>
			</CardActions>
		</Card>
	);
};
